export function withinThreshold(value, target, plusMinus = 0) {
    const lower = target - plusMinus;
    const upper = target + plusMinus;
    return value >= lower && value <= upper;
}
